
export default class BookingCondition {

    constructor(apiResponse) {
        this.id = apiResponse.id;
        this.cancellationPolicy = apiResponse.cancellationPolicy;
        this.refundableUntil = apiResponse.refundableUntil ? new Date(apiResponse.refundableUntil) : null;
        this.touristTaxPolicy = apiResponse.touristTaxPolicy;
        this.touristTaxUnitPrice = apiResponse.touristTaxUnitPrice ? Number.parseFloat(apiResponse.touristTaxUnitPrice) : null;

        this.checkInFrom = apiResponse.checkInFrom ? new Date(apiResponse.checkInFrom.substring(0, 19)) : null;
        this.checkOutBefore = apiResponse.checkOutBefore ? new Date(apiResponse.checkOutBefore.substring(0, 19)) : null;
    }

    clone() {
        const bookingCondition = new BookingCondition({});
        bookingCondition.id = this.id;
        bookingCondition.cancellationPolicy = this.cancellationPolicy;
        bookingCondition.refundableUntil = this.refundableUntil ? new Date(this.refundableUntil) : null;
        bookingCondition.touristTaxPolicy = this.touristTaxPolicy;
        bookingCondition.touristTaxUnitPrice = this.touristTaxUnitPrice;
        bookingCondition.checkInFrom = this.checkInFrom ? new Date(this.checkInFrom) : null;
        bookingCondition.checkOutBefore = this.checkOutBefore ? new Date(this.checkOutBefore) : null;
        return bookingCondition;
    }
}